import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const KEY_STORAGE = "listing_ai_api_key";     // internal Lab (service key)
const TOKEN_STORAGE = "magicad_token";        // customer portal (user JWT)
const USER_STORAGE = "magicad_user";

export const getApiKey = () => localStorage.getItem(KEY_STORAGE) || "";
export const setApiKey = (k) => (k ? localStorage.setItem(KEY_STORAGE, k) : localStorage.removeItem(KEY_STORAGE));
export const getToken = () => localStorage.getItem(TOKEN_STORAGE) || "";
export const setSession = (token, user) => {
  if (token) localStorage.setItem(TOKEN_STORAGE, token); else localStorage.removeItem(TOKEN_STORAGE);
  if (user) localStorage.setItem(USER_STORAGE, JSON.stringify(user)); else localStorage.removeItem(USER_STORAGE);
};
export const getUser = () => { try { return JSON.parse(localStorage.getItem(USER_STORAGE) || "null"); } catch { return null; } };

/** Which credential a request should carry: the Lab (/lab/...) speaks with the service key, everything else with the user token. */
const inLab = () => typeof window !== "undefined" && window.location.pathname.startsWith("/lab");

export const api = axios.create({ baseURL: `${BACKEND}/api`, timeout: 120000 });
api.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  const key = getApiKey();
  const token = getToken();
  if (inLab() && key) cfg.headers["X-API-Key"] = key;
  else if (token) cfg.headers.Authorization = `Bearer ${token}`;
  else if (key) cfg.headers["X-API-Key"] = key;
  return cfg;
});

export const errorMessage = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Noe gikk galt";
  if (typeof d === "string") return d;
  if (d.message) return d.errors ? `${d.message}: ${JSON.stringify(d.errors).slice(0, 200)}` : d.message;
  return JSON.stringify(d).slice(0, 200);
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("nb-NO", { dateStyle: "medium", timeStyle: "short" }) : "–");
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("nb-NO", { day: "numeric", month: "short", year: "numeric" }) : "–");
export const pct = (v) => (v == null ? "–" : `${Math.round(v * 100)}`);
export const ms = (v) => (v == null ? "–" : v < 1000 ? `${Math.round(v)} ms` : `${(v / 1000).toFixed(1)} s`);
export const usd = (v) => (v == null ? "–" : `$${v.toFixed(3)}`);
export const shortId = (id) => (id ? `${id.slice(0, 12)}…` : "–");

/** Customer-safe name for an ad/job: the listing title, address or owner-given name; else a dated label. The raw
 *  external_property_id is only shown when `technical` (Lab) asks for it. */
export const jobTitle = (j, { technical = false } = {}) => {
  if (!j) return "Annonse";
  const t = j.title || j.source_title;
  if (t) return t;
  if (technical && j.external_property_id) return j.external_property_id;
  const n = j.images_count ?? j.images_total ?? j.summary?.images_total ?? j.images?.length;
  const day = fmtDay(j.created_at);
  return n ? `${n} bilder · ${day}` : `Annonse · ${day}`;
};
